import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=27307078&scoped=true&"
import script from "./TemplatePreview.vue?vue&type=script&lang=js&"
export * from "./TemplatePreview.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePreview.vue?vue&type=style&index=0&id=27307078&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27307078",
  null
  
)

export default component.exports